export default "__VITE_ASSET__BbPaS2tO__"